module.exports = __webpack_public_path__ + "files/48b6d8b04ed4d06330833ed1327a872e.png";